import React from 'react'
import { Link } from 'react-router-dom';
import * as stylex from '@stylexjs/stylex';
import { styles } from '@/styles/Homepage.stylex';
import { ArrowRight } from 'lucide-react';
import { useState } from 'react';

interface ModelCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  features: string[];
  href: string;
  category: string;
  style?: stylex.StyleXStyles;
}

export function ModelCard({ title, description, icon, features, href, category, style }: ModelCardProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      {...stylex.props(style)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Animated Top Border */}
      <div {...stylex.props(styles.modelCardTopBorder, isHovered && styles.modelCardTopBorderHover)} />

      <div {...stylex.props(styles.modelCardHeader)}>
        <div {...stylex.props(styles.modelCardIcon)}>
          {icon}
        </div>
        <span {...stylex.props(styles.modelCardCategory)}>{category}</span>
      </div>

      <h3 {...stylex.props(styles.modelCardTitle)}>{title}</h3>
      <p {...stylex.props(styles.modelCardDescription)}>{description}</p>

      <ul {...stylex.props(styles.modelCardFeatures)}>
        {features.map((feature, index) => (
          <li key={index} {...stylex.props(styles.featureItem)}>
            {feature}
          </li>
        ))}
      </ul>

      <Link to={href} {...stylex.props(styles.modelCardLink)}>
        Learn More <ArrowRight size={16} />
      </Link>
    </div>
  );
}